export enum revisionChangeTypeEnum {
  SHARED = 'shared',
  UNSHARED = 'unshared',
  IMPLICIT_UNSHARED = 'implicit_unshared',
  LOCKED = 'locked',
  UNLOCKED = 'unlocked',
  EDITED = 'edited',
  EXPORTED = 'exported',
  CREATED = 'created',
  EDIT_PERMISSION_ADDED = 'permission_added',
  EDIT_PERMISSION_REMOVED = 'permission_removed',
  RESTORED = 'restored',
  DELETED = 'deleted',
  SENT_TO_ESDH = 'sent_to_esdh',
  JOURNALIZED_TO_ESDH = 'journalized_to_esdh',
  ESDH_JOURNALIZATION_FAILED = 'esdh_journalization_failed',
  RESENT_TO_ESDH = 'resent_to_esdh',
  MARK_FOR_MANUAL_JOURNALIZE = 'mark_for_manual_journalize',
  MANUALLY_JOURNALIZED = 'manually_journalized',
}
